import { Graphviz } from 'graphviz-react';
import styled from 'styled-components';

export const Container = styled.div`
    margin-bottom: 1rem;
    display: flex;
    height:100%;
    background-color: white;
`;

export const GraphContainer = styled.div`
    width: 100%;
`;

export default styled(Graphviz)`
    padding: 1rem;
    overflow: hidden;
    height: 100%;
    width: 100%;
    .graph{
        .node {
            >ellipse 
            {
                fill:#40A9FF;
                stroke: #5A6265;

            }
            > text 
            {
               font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen','Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',sans-serif;
               font-size: 14px;
               fill : #FCFCFF;
            }
        }
        .edge>path {
            stroke: #5A6265;
        }
        .edge>polygon {
            stroke: #5A6265;
            fill: #5A6265;
        }
        .edge>text{
            fill: #5A6265;
        }
    }
`;
